// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3uzI2","buttons":"RemoveExpirationActionButtons_buttons__lgLYQ"};